import { motion } from 'framer-motion';
import { ExperienceItem } from '../data/portfolioData';

interface TimelineProps {
  items: ExperienceItem[];
  color: string;
}

export default function Timeline({ items, color }: TimelineProps) {
  return (
    <div className="relative pl-6">
      <div
        className="absolute left-2 top-0 bottom-0 w-px"
        style={{ background: `linear-gradient(to bottom, ${color}, transparent)` }}
      />

      {items.map((item, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: i * 0.15, duration: 0.4 }}
          className="relative mb-8 last:mb-0"
        >
          <div
            className="absolute -left-4 top-1.5 w-3 h-3 rounded-full border-2"
            style={{
              borderColor: color,
              background: `${color}40`,
              boxShadow: `0 0 10px ${color}60`,
            }}
          />

          <div
            className="rounded-xl border p-5 backdrop-blur-md"
            style={{
              background: `linear-gradient(135deg, ${color}08, ${color}03)`,
              borderColor: `${color}25`,
            }}
          >
            <h3 className="text-white font-semibold text-base mb-2">{item.role}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">{item.description}</p>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
